






























import { mapState } from "vuex";
import TextLabel from "@/common/components/atoms/TextLabel.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import { Prop, Vue, Component } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";

@Component({
  components: {
    TextLabel,
    PointNotation
  }
})
export default class TheC01ItemInfo extends Vue {
  @Prop({ type: [String, Number], required: true, default: "" }) id!:
    | string
    | number;
  @Prop({ type: String, required: true, default: "" }) name!: string;
  @Prop({ type: Number, required: false, default: 0 }) point!: number;
  @Prop({ type: Number, required: false, default: 0 }) stock!: number;
  @Prop({ type: Number, required: false, default: 0 }) discountRate!: number;
  @Prop({ type: [String, Boolean], required: false, default: "" }) status!:
    | string
    | boolean;
  @Prop({ type: Boolean, required: true }) isQuantityControl!: boolean;
  @Prop({ type: Boolean, required: true, default: false })
  isBenepoExchange!: boolean;

  get unit() {
    return commons.unit;
  }
  get colorCode() {
    return this.stock > 0 ? commons.colorCode : "#333";
  }

  get stockText() {
    return this.stock > 0 ? this.stock : "現在在庫切れです";
  }
}
